import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import NoticeBoardCategorytListLayer from "../components/NoticeboardCategoryListLayer";
 
const NoticeBoardCategoryListPage = () => {
  return (
    <>
    
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Noticeboard Category  </h5><Breadcrumb title="Noticeboard Category" /></div>
 
        <NoticeBoardCategorytListLayer />
 
 
    </>
  );
};
 
export default NoticeBoardCategoryListPage;
 
 